export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/rushing-icon.svg?a6fc9c460d0598538acdfd6a3f03db1f";